import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';

function Title({ children }) {
  return children;
}

function CategorySkeleton({ isEdition, children }) {
  return (
    <Grid container data-testid="categorySkeleton" direction="column" spacing={3}>
      <Grid item>{children}</Grid>

      {isEdition && (
        <Grid item>
          <Skeleton height={70} variant="rectangular" width="100%" />
        </Grid>
      )}

      <Grid item>
        <Skeleton height={25} varaint="text" width={150} />
        <Skeleton height={70} variant="text" width="100%" />
      </Grid>

      <Grid item xs={12}>
        <Box mb={3}>
          <Skeleton height={25} varaint="text" width={150} />
          <Skeleton height={15} variant="text" width={150} />
        </Box>

        <Grid container spacing={3}>
          {[...Array(5).keys()].map((item) => (
            <Grid item key={item} xs={6}>
              <Skeleton height={45} variant="rectangular" width="100%" />
            </Grid>
          ))}
        </Grid>

        <Box mt={3}>
          <Divider />
        </Box>
      </Grid>

      <Grid item>
        <Skeleton height={25} varaint="text" width={150} />
        <Skeleton height={15} variant="text" width={150} />
        <Skeleton height={70} variant="text" width="100%" />

        <Box mt={3}>
          <Divider />
        </Box>
      </Grid>

      <Grid item>
        <Box mb={3}>
          <Skeleton height={25} varaint="text" width={150} />
          <Skeleton height={15} variant="text" width={150} />
        </Box>

        <Skeleton height={40} variant="rectangular" width={180} />

        <Box mt={3}>
          <Divider />
        </Box>
      </Grid>

      <Grid item>
        <Box mb={3}>
          <Skeleton height={25} varaint="text" width={150} />
          <Skeleton height={15} variant="text" width={150} />
        </Box>

        <Box display="grid" gridAutoFlow="column" justifyContent="space-between">
          {[...Array(7).keys()].map((value) => (
            <Skeleton height={40} key={value} variant="circular" width={40} />
          ))}
        </Box>

        <Box mt={3}>
          <Divider />
        </Box>
      </Grid>

      <Grid item>
        <Skeleton height={25} varaint="text" width={150} />
        <Skeleton height={15} variant="text" width="100%" />
        <Box columnGap={1} display="flex" justifyContent="space-between">
          <Skeleton height={70} variant="text" width="100%" />
          <Skeleton height={70} variant="text" width={170} />
        </Box>
      </Grid>
    </Grid>
  );
}

CategorySkeleton.Title = Title;

CategorySkeleton.propTypes = {
  children: PropTypes.node,
  isEdition: PropTypes.bool,
};

export default CategorySkeleton;
